const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    contributors: [],
    contributorsPending: false,
    contributorsError: null,
  },
  mutations: {
    setContributors (state, value) {
      state.contributors = value
    },
    setContributorsPending (state, value) {
      state.contributorsPending = value
    },
    setContributorsError (state, value) {
      state.contributorsError = value
    },
    updateContributor (state, value) {
      state.contributors = state.contributors.map(el => el.id === value.id ? {...el, ...value} : el)
    },
  },
  actions: {
    getContributors({state, commit}){
      commit('setContributorsPending', true)
      fb.db.collection("contributors").orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
          let contributors = []
          querySnapshot.forEach((doc) => {
            contributors.push({ id: doc.id, ...doc.data() })
          });
          commit('setContributors', contributors)
          commit('setContributorsPending', false)
        })
        .catch((error) => {
          commit('setContributorsPending', false)
          commit('setContributorsError', error)
        })
    },
  }
}